import type { SVGProps } from "react";

export const Quickbooks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    enableBackground="new 0 0 2500 2500"
    viewBox="0 0 2500 2500"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Quickbooks</title>
    <circle cx="1250" cy="1250" fill="#2ca01c" r="1250" />
    <path
      d="m301.3 1249.6c.1 282.6 228 512.4 510.6 514.9h72.3v-188.9h-72.3c-175.2 47.8-355.9-55.5-403.6-230.7-.4-1.4-.7-2.8-1.1-4.2-49.1-177.5 53.7-361.4 230.6-412.5h36.1c45.3-9.9 92.2-9.9 137.5 0h175.6v1002.9c-.9 106.1 84.4 192.9 190.5 193.9v-1395.4h-364.5c-284.6 1.5-514 233.4-512.5 518v.1zm1387.5-519.8h-72.3v198.9h72.3c174.8-47.7 355.1 55.3 402.8 230 .4 1.3.7 2.7 1.1 4 48.8 176.9-53.7 360.1-229.9 411.1h-36.1c-45.3 9.9-92.2 9.9-137.5 0h-175.6v-1002.8c.9-106.1-84.4-192.9-190.5-193.9v1397.4h364.5c287.1-4.5 516.2-240.8 511.8-527.9-4.4-280.8-230.9-507.4-511.8-511.8z"
      fill="#fff"
    />
  </svg>
);

export default Quickbooks;
